import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-error-tooltip',
  template: `
    <div 
      [hidden]="!showAndHideMessage && !showMessage" 
      [ngClass]="showAndHideMessage ? 'error-tooltip fade-in-out' : showMessage ? 'error-tooltip fade-in' : 'error-tooltip'"
      [ngStyle]="{'margin-top': marginTop, 'margin-bottom': marginBottom}"
    >
        <span class="error-text"> {{ message }} </span>
    </div>
    <div 
      [hidden]="showAndHideMessage || showMessage" 
      [ngStyle]="{ 'padding': '2px 6px', 'margin-top': marginTop, 'margin-bottom': marginBottom, 'opacity': 0.0}"
    >
        <span class="error-text"> Place Holder </span>
    </div>
    `,
  styles: [`
      .error-tooltip {
          background: red;
          color: white;
          width: fit-content;
          padding: 2px;
          border-radius: 3px;
          padding: 2px 6px;
          z-index: 2;
      }

      .fade-in-out {
        -webkit-animation: fade 4s linear forwards;
        animation: fade 4s linear forwards;
      }

      .fade-in {
        -webkit-animation: in 2s linear forwards;
        animation: in 2s linear forwards;
      }

      @-webkit-keyframes fade {
        0%, 100% {opacity: 0}
        50% {opacity: 1}
      }

      @keyframes fade {
        0%, 100% {opacity: 0}
        50% {opacity: 1}
      }

      @-webkit-keyframes in {
        0% {opacity: 0}
        100% {opacity: 1}
      }

      @keyframes in {
        0% {opacity: 0}
        100% {opacity: 1}
      }
  `]
})

export class ErrorTooltipComponent {
  @Input()
  marginTop: string;
  @Input()
  marginBottom: string;

  public message: string;
  public showAndHideMessage = false;
  public showMessage = false;
  private pendingTimeout = false;

  public showAndHide(message: string) {
    if (!this.pendingTimeout) {
      this.message = message;
      this.pendingTimeout = true;
      this.showAndHideMessage = true;
      setTimeout(() => {
        this.showAndHideMessage = false;
        this.pendingTimeout = false;
      }, 6000);
    }
  }

  public show(message: string) {

    this.message = message;
    this.showMessage = true;
  }

  public hide() {

    this.showMessage = false;
  }
}
